import React from 'react';
import { Users, Calendar, Award } from 'lucide-react';

const FilterBar = ({ filters, onFilterChange }) => {
  const timePeriodsOptions = [
    { value: 'daily', label: 'Today' },
    { value: 'weekly', label: 'This Week' },
    { value: 'monthly', label: 'This Month' },
    { value: 'all-time', label: 'All Time' }
  ];

  const userTypeOptions = [
    { value: 'all', label: 'Everyone' },
    { value: 'user', label: 'Students' },
    { value: 'editor', label: 'Educators' },
    { value: 'talent', label: 'Talent' }
  ];

  const contentCategoryOptions = [
    { value: 'all', label: 'All Content' },
    { value: 'musicals', label: 'Musicals' },
    { value: 'roles', label: 'Roles' },
    { value: 'songs', label: 'Songs' }
  ];

  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Time Period Filter */}
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
            <Calendar className="w-4 h-4 text-purple-600" />
            Time Period
          </label>
          <select
            value={filters?.timePeriod || 'all-time'}
            onChange={(e) => onFilterChange({ ...filters, timePeriod: e?.target?.value })}
            className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none"
          >
            {timePeriodsOptions?.map(option => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>

        {/* User Type Filter */}
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
            <Users className="w-4 h-4 text-purple-600" />
            User Type
          </label>
          <select
            value={filters?.userType || 'all'}
            onChange={(e) => onFilterChange({ ...filters, userType: e?.target?.value })}
            className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none"
          >
            {userTypeOptions?.map(option => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Content Category Filter */}
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
            <Award className="w-4 h-4 text-purple-600" />
            Content Category
          </label>
          <select
            value={filters?.contentCategory || 'all'}
            onChange={(e) => onFilterChange({ ...filters, contentCategory: e?.target?.value })}
            className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none"
          >
            {contentCategoryOptions?.map(option => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;